import type { CommunityTabItem } from '../community-tabs';

export const mapCommunityTabToPathName = (communityId: string, key: CommunityTabItem) =>
  ({
    '/about': `/communities/${communityId}/about`,
    '/assets': `/communities/${communityId}/assets`,
    '/feed': `/communities/${communityId}/feed`,
    '/members': `/communities/${communityId}/members`,
  })[key];
